import type { JSX } from 'react'
import type { IButtonProps } from 'atoms/Button'
import type { IButtonGroupProps } from '../ButtonGroup'

import { SecondaryOpacityFavoriteToggleButton } from 'atoms/ActionButton/Templates'
import {
  PlayPrimaryButton,
  SecondaryOpacityFontButton1Button,
} from 'atoms/Button/Templates'
import { ButtonGroup } from '../ButtonGroup'

export interface IButtonGroupTemplateMoviesProps extends Omit<
  IButtonGroupProps,
  'children'
> {
  list: [IButtonProps['title'], IButtonProps['title']]
}

export const ButtonGroupTemplateMovies = ({
  list,
  ...rest
}: IButtonGroupTemplateMoviesProps): JSX.Element => (
  <ButtonGroup {...rest}>
    <PlayPrimaryButton title={list?.[0] || ''} />
    <SecondaryOpacityFontButton1Button title={list?.[1] || ''} />
    <SecondaryOpacityFavoriteToggleButton />
  </ButtonGroup>
)
